import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { UserData } from '../../providers/user-data';
import { HistoryData } from '../../providers/history-data';
import { ParplatzData } from '../../providers/pp-data';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'kontrollinfos',
  templateUrl: 'kontrollinfos.html'
})
export class KontrollinfosComponent {

  text: string;
  bLoading: boolean;
  bShowInfo: boolean;
  kontrollinfoConent: string;
  kontrinfourl: string;

  private _grundid;
  @Input('grundid') 
  get grundid(): number {
    return this._grundid;
  }
  set grundid(value: number) {
    console.log("set grundid");

    this._grundid = value;    
    this.autoshowContent();

    //this.loadData();
  }      

  private _showFabButton;
  @Input('showFabButton') 
  get showFabButton(): number {
    return this._showFabButton;
  }
  set showFabButton(value: number) {
    //console.log("set fab");
    this._showFabButton = value;    
    this.autoshowContent();
    //this.loadData();
  }  



  constructor(
    public ppData: ParplatzData
    , private iab: InAppBrowser
    ) {
    this.bShowInfo = false;
  }

  loadData(){
    this.bLoading = true;
    this.ppData.loadKontrollinfo(this._grundid).then( (res:any) =>{
      this.bLoading = false;
      if(res){
        //console.log(res);
        this.kontrollinfoConent = res.body.view.value;
        this.kontrinfourl = 'https://parkix.atlassian.net/wiki'+res._links.webui;
  
      }
      else{
        this.kontrollinfoConent = "keine Informationen";
      }
      //console.log(res.value);      
    })        
  }

  autoshowContent(){
    if(this._showFabButton == 0 && this._grundid>0){
      this.toggleVisibility();
    }
  }

  toggleVisibility(){
    console.log(this._grundid);
    this.bShowInfo = !this.bShowInfo;
    if(this.bShowInfo){
      this.loadData();
    }
  }

  openURLBrowser(){
    const browser = this.iab.create(this.kontrinfourl, '_system');
   }

}



// WEBPACK FOOTER //
// ./src/components/kontrollinfos/kontrollinfos.ts